import { render, staticRenderFns } from "./CustomerDescription.vue?vue&type=template&id=c737dea2"
import script from "./CustomerDescription.vue?vue&type=script&lang=js"
export * from "./CustomerDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports